export default class EndGameCopy extends Phaser.Group {
  constructor(game) {
    super(game);

    // copy container
    this.copy1 = this.game.make.text(0, 0, this.game.copy.getCopy('end_game_line1'), {
      font: '52px ' + this.game.titleFontStyle,
      fill: '#FFFFFF',
      align: 'center',
      wordWrap: true,
      wordWrapWidth: 700,
      boundsAlignH: 'center',
      boundsAlignV: 'bottom',
    });

    this.copy1.setTextBounds(
      0,
      this.game.defaultHeight * 0.2,
      this.game.defaultWidth,
      this.game.defaultHeight * 0.35
    );
    this.copy1.setShadow(0, 4, 'rgba(0,0,0,0.15)', 0);
    this.add(this.copy1);

    // copy container
    this.copy2 = this.game.make.text(0, 0, this.game.copy.getCopy('end_game_line2'), {
      font: '40px ' + this.game.titleFontStyle,
      fill: '#FFFFFF',
      align: 'center',
      wordWrap: true,
      wordWrapWidth: 600,
      boundsAlignH: 'center',
      boundsAlignV: 'top',
    });

    this.copy2.setTextBounds(
      0,
      this.game.defaultHeight * 0.6,
      this.game.defaultWidth,
      this.game.defaultHeight * 0.45
    );
    this.copy2.setShadow(0, 4, 'rgba(0,0,0,0.15)', 0);
    this.add(this.copy2);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/endGame/EndGameCopy.js